import { Injectable } from '@angular/core';
import { CacheService } from 'projects/common/src/app/services';
import { HttpClient } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { IReportResponse } from '../interfaces/report-response';
import { catchError } from 'rxjs/operators';
import { IOutputFilter } from '../../core/interfaces/output-filter';
import { UrlBuilderService } from 'projects/communication/src/app/services/url-builder.service';

@Injectable({ providedIn: 'root' })
export class ReportService {
  constructor(private cacheService: CacheService, private http: HttpClient, private urlBuilder: UrlBuilderService) {}

  /**
   * Get transit data from 'getTransitReport' endpoint
   */
  public GetTransitReportData(params: any): Promise<any> {
    const url = `${this.urlBuilder.apiUrl}/Report/GetTransitReport`;
    return this.http.get(url, { params }).toPromise();
  }

  /**
   * Get transit excel report from 'getTransitReportDocument' endpoint
   */
  public GetTransitReportExcel(params: any): Promise<any> {
    const url = `${this.urlBuilder.apiUrl}/Report/GetTransitReportDocument`;
    return this.http.get(url, { params, responseType: 'blob' }).toPromise();
  }

  /**
   * Get status machine data
   *
   * @param selectedFilters Filters to get machine status report data
   */
  public getStatusMachineReport(selectedFilters: IOutputFilter): Observable<any> {
    const companyId = this.cacheService.local('session').user.company.id;

    const params = {
      startDate: selectedFilters.startDate,
      endDate: selectedFilters.endDate,
      shiftId: selectedFilters.shiftId,
      machineTypeId: selectedFilters.machineTypeId,
      mineId: selectedFilters.mineId,
      companyId,
      machineList: selectedFilters.machineList,
    };
    const url = `${this.urlBuilder.apiUrl}/Report/GetStatusMachineReport`;

    return this.http.get<IReportResponse>(url, { params }).pipe(catchError((err) => this.handleError(err)));
  }

  /**
   * Get excel from GetStatusMachineReportDocument endpoint
   *
   * @param selectedFilters Filters to get machine status report data
   */
  public getStatusMachineReportExcel(selectedFilters: IOutputFilter): Observable<any> {
    const companyId = this.cacheService.local('session').user.company.id;

    const params = {
      startDate: selectedFilters.startDate,
      endDate: selectedFilters.endDate,
      shiftId: selectedFilters.shiftId,
      machineTypeId: selectedFilters.machineTypeId,
      mineId: selectedFilters.mineId,
      companyId,
      machineList: selectedFilters.machineList,
    };
    const url = `${this.urlBuilder.apiUrl}/Report/GetStatusMachineReportDocument`;
    return this.http.get(url, { params, responseType: 'blob' }).pipe(catchError((error) => throwError(() => error.error)));
  }

  /**
   * Function to set params and send selected filters to request
   *
   * @param selectedFilters Filters selected to save params
   */
  private setParams(selectedFilters: IOutputFilter): any {
    const companyId = this.cacheService.local('session').user.company.id;

    return {
      startDate: selectedFilters.startDate,
      endDate: selectedFilters.endDate,
      shiftId: String(selectedFilters.shiftId),
      machineTypeList: String(selectedFilters.machineTypeId),
      machineList: selectedFilters.machineId,
      mineId: selectedFilters.zoneId,
      companyId,
    };
  }

  /**
   * Handle error
   *
   * @param err error
   */
  private handleError(err: any): Observable<any> {
    console.log(err);
    return throwError(err);
  }

  public getReport(params: any): Observable<IReportResponse[]> {
    const url = `${this.urlBuilder.apiUrl}/Report/GetReport`;
    return this.http.get<IReportResponse[]>(url, { params }).pipe(catchError((error) => throwError(() => error.error)));
  }
}
